import { ValidatorCategory } from './validators.js';
export const NO_DUPLICATE_FACTION = {
    id: 'foldernodupfaction',
    name: 'No Duplicate Faction',
    default: false,
    description: 'Each list must have a different faction',
    category: ValidatorCategory.Folder,
};
export const NO_DUPLICATE_WARSCROLLS = {
    id: 'foldernodupwarscrolls',
    name: 'No Duplicate Warscrolls',
    default: false,
    description: 'Each warscroll can only appear in a single list',
    category: ValidatorCategory.Folder,
};
export const NO_DUPLICATE_MANIFESTATITON_LORE = {
    id: 'foldernodupmanlore',
    name: 'No Duplicate Manifestation Lore',
    default: false,
    description: 'Each list must have a different manifestation lore if they have one',
    category: ValidatorCategory.Folder,
};
export const NO_DUPLICATE_BATTLE_TACTICS = {
    id: 'foldernodupbattactics',
    name: 'No Duplicate Battle Tactics',
    default: false,
    description: 'Each battle tactic card may appear only once',
    category: ValidatorCategory.Folder,
};
export const NO_DUPLICATE_ENHANCEMENTS = {
    id: 'foldernodupenhancements',
    name: 'No Duplicate Enhancements',
    default: false,
    description: 'Enhancements must be unique across lists',
    category: ValidatorCategory.Folder,
};
export const NO_DUPLICATE_ROR = {
    id: 'foldernoduprors',
    name: 'No Duplicate Regiments of Renown',
    default: false,
    description: 'Each Regiment of Renown may appear only once',
    category: ValidatorCategory.Folder,
};
export const EVERY_GRAND_ALLIANCE = {
    id: 'foldereveryga',
    name: 'Every Grand Alliance',
    default: false,
    description: 'There must be at least one list from each Grand Alliance',
    category: ValidatorCategory.Folder,
};
export const teamValidators = [
    NO_DUPLICATE_FACTION,
    NO_DUPLICATE_WARSCROLLS,
    NO_DUPLICATE_MANIFESTATITON_LORE,
    // NO_DUPLICATE_BATTLE_TACTICS,
    NO_DUPLICATE_ENHANCEMENTS,
    NO_DUPLICATE_ROR,
    EVERY_GRAND_ALLIANCE,
];
